import { SelectProductActionTypes, SelectProductActions } from './select-product.actions';
import { Product } from '../../dto';

export const SELECT_PRODUCT_STORE_NAME = 'selectProduct';

export const initialState: Product = null;

export function selectProductReducer(state = initialState, action: SelectProductActions) {
  switch (action.type) {
    case SelectProductActionTypes.SET_PRODUCT:
      return action.payload ? action.payload : null;
    case SelectProductActionTypes.REMOVE_PRODUCT:
      return null;
    default:
      return state;
  }
}
